"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOfflineEnv = exports.default = void 0;

var _index = require("../constants/index");

var runtime = {
  env: 'local',
  pageMode: _index.SSR_MODE,
  // ssr/export/download
  // routeNameMap: {},
  routeConfig: {},
  shouldLog: false,
  shouldReport: true,
  deviceLevel: 'NOT_READY',
  whiteApiDomain: ['akulaku.com', 'silvrrplus.com']
};
var _default = {
  set: function set(param, value) {
    if (runtime.hasOwnProperty(param)) {
      if (Array.isArray(runtime[param])) {
        runtime[param] = runtime[param].concat(value);
      } else {
        runtime[param] = value;
      }

      return true;
    } else {
      return false;
    }
  },
  get: function get(param) {
    if (runtime.hasOwnProperty(param)) {
      return runtime[param];
    } else {
      return false;
    }
  }
}; // 是否离线包模式

exports.default = _default;

var isOfflineEnv = function isOfflineEnv() {
  return !!window.__AL_OFFLINE_ENABLE;
};

exports.isOfflineEnv = isOfflineEnv;